import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { clearCustomRotationAction, saveCustomRotationAnswerAction } from '../../../../store/quiz/quiz.actions';
import { useHistory } from 'react-router-dom';
import { useFadeObserver } from '../../hooks/fadeObserver.hook';

export const Rotation = ({ answers, name, image, index }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef(null);

  const onClick = useCallback(
    async event => {
      event.preventDefault();

      await dispatch(clearCustomRotationAction());

      for (let i = 0; i < answers.length; i += 1) {
        let curAnswer = i + 1;
        if (curAnswer > 2 && answers.length !== 6) {
          curAnswer += 1;
        }

        await dispatch(saveCustomRotationAnswerAction(curAnswer, answers[i]));
      }

      history.push('/filter_checkout?finished=true');
      window.location.reload();
    },
    [dispatch, history, answers]
  );

  useFadeObserver(ref);

  return (
    <div className="col-12 col-sm-6 col-lg-3 d-flex justify-content-center mb-30px">
      <a
        href="/filter_checkout?finished=true"
        aria-label={`Shop ${name}`}
        className={`mw-300px rotation-option-card rounded d-flex flex-grow-1 fade-on-screen fade-delay-${index} position-relative cursor-pointer`}
        onClick={onClick}
        ref={ref}
      >
        <div className="p-4 position-absolute rotation-card d-flex flex-column justify-content-between align-items-start">
          <div className="font-weight-bold rotation-title">{name}</div>
          <span className="btn btn-primary rounded-circle rotation-button">
            <img
              src="https://bottomless.imgix.net/landing-coffee-v2/icon-arrow-right.png?auto=compress,format&h=24"
              srcSet="
                https://bottomless.imgix.net/landing-coffee-v2/icon-arrow-right.png?auto=compress,format&h=24 1x,
                https://bottomless.imgix.net/landing-coffee-v2/icon-arrow-right.png?auto=compress,format&h=48 2x
              "
              alt="->"
              width="24"
              height="24"
            />
          </span>
        </div>
        <img
          data-srcset={`
            ${image}?auto=compress,format&h=294 1x,
            ${image}?auto=compress,format&h=588 2x
          `}
          data-src={`${image}?auto=compress,format&h=294`}
          className="lazyload rotation-image rounded img-fluid w-100"
          height="294"
          alt={name}
        />
      </a>
    </div>
  );
};

Rotation.propTypes = {
  image: PropTypes.string.isRequired,
  answers: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};
